export default "__VITE_ASSET__BPWyROp2__"